import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { UploadImageButton } from "../../shared/uploadImageButton";
import { BasicButton } from "../../shared/basicButton";
import { BasicTextBox } from "../../shared/basicTextBox";
import { useApiCall } from "../../hooks/useApiCall";
import { uploadMyImageApi } from "../../api/cardDataApi";



export function UploadMyImagePage() {

      const [loading, setLoading] = React.useState(false);
      const [newImage, setNewImage] = React.useState<string | undefined>(undefined);
        const [error, setError] = React.useState('');
        const [newAthleteName, setNewAthleteName] = React.useState<string>('');

        const uploadMyImageApiRequest = useApiCall(uploadMyImageApi);

        function handleNewAthleteName(e: React.ChangeEvent<HTMLInputElement>) {
            setNewAthleteName(e.target.value);
        }

    

        async function onChangeImage(selectedImage: string): Promise<void> {
            setNewImage(selectedImage);
        }

        async function uploadImage() {

            if (!newAthleteName) {
                setError('Athlete Name is required');
                return;
            }

            if (!newImage) {
                setError('Image is required');
                return;
            }

            try {
                setLoading(true);
                setError('');
                await uploadMyImageApiRequest.request({ athleteName: newAthleteName, image: newImage });
            } catch (error) {
                setError('Failed to upload image');
            } finally {
                setLoading(false);
            }
        }




return (
		<Box display="flex" justifyContent="center" alignItems="flex-start" minHeight="100vh" px={2}>
			<Box width="100%" maxWidth="400px">

                <br/>

				{loading && <CircularProgress />}

                <Box>

                            <BasicTextBox id='txtAthleteName'
                                label='Athlete Name*'
                                errorMessage={error}
                                maxLength={20}
                                width={250}
                                value={newAthleteName}
                                onChange={handleNewAthleteName} />

                            
                </Box>

                 <Box sx={{width:500, mt:2}}>
                          {newImage && (
                            <img
                              src={newImage}
                              height={100}
                              width={100}
                              alt="logo"
                              style={{ border: '1px solid #909090' }}
                            />
                          )}

                          <br/>
                          
                          <UploadImageButton
                            id="uploadImage"
                            onChange={onChangeImage}
                            aspectRatio={1}
                          />
                        </Box>

                        <br/>

                        <Box>
                            <BasicButton onClick={uploadImage} labelText="Upload" />
                        </Box>


			</Box>
		</Box>
	);
}
